import { Button, Form, Input, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { App } from 'antd';
import { getHttpErrorMessage } from 'utils/http';
import { captureException } from 'utils/errors';

function SendEmailModal({ open, onClose, onSubmit, defaultToEmail }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ to_email: defaultToEmail || '' });
    }
  }, [open, defaultToEmail, form]);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);
      const payload = {
        subject: values.subject?.trim() || '',
        body: values.body?.trim() || '',
        to_email: values.to_email?.trim().toLowerCase() || '',
      };
      onSubmit(payload)
        .then(() => {
          form.resetFields();
          handleClose();
        })
        .catch((e) => {
          captureException(e);
          message.error(getHttpErrorMessage(e) || 'Failed to send email');
        })
        .finally(() => setLoading(false));
    }).catch(() => {});
  };

  return (
    <Modal
      title="Send Email"
      open={open}
      onCancel={handleClose}
      footer={(
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={handleSubmit}>
            Send
          </Button>
        </div>
      )}
      width={500}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="to_email"
          label="To"
          rules={[
            { required: true, message: 'Recipient email is required' },
            { type: 'email', message: 'Please enter a valid email address' },
          ]}
        >
          <Input type="email" placeholder="recipient@example.com" />
        </Form.Item>
        <Form.Item
          name="subject"
          label="Subject"
          rules={[{ required: true, message: 'Subject is required' }]}
        >
          <Input placeholder="Email subject" />
        </Form.Item>
        <Form.Item name="body" label="Body">
          <Input.TextArea placeholder="Email body..." rows={6} autoSize={{ minRows: 6, maxRows: 12 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SendEmailModal;
